/**
 * @generated SignedSource<<45bab20a16c6bc5791f366589a28bfc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameMailingListInput = {
  id: string;
  name: string;
};
export type MailingListViewRenameMutation$variables = {
  input: RenameMailingListInput;
};
export type MailingListViewRenameMutation$data = {
  readonly renameMailingList: {
    readonly id: string;
    readonly name: string;
  };
};
export type MailingListViewRenameMutation = {
  response: MailingListViewRenameMutation$data;
  variables: MailingListViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "renameMailingList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fc790d32d73c73e2cae0d210b68661a2",
    "id": null,
    "metadata": {},
    "name": "MailingListViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListViewRenameMutation(\n  $input: RenameMailingListInput!\n) {\n  renameMailingList(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5347f4936a64fd4078e3601a18d2b09";

export default node;
